// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"b69f58ef","579":"001f045d","625":"d913c17f","943":"be8129c3","979":"5643cba1"}[chunkId] + ".chunk.css";
};